import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check local storage for existing auth on app load
    const storedToken = localStorage.getItem('lead_app_token');
    const storedUser = localStorage.getItem('lead_app_user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
    
    setIsLoading(false);
  }, []);

  const login = useCallback((authData) => {
    const { token, userID, fullName, role } = authData;
    const userData = { userID, fullName, role };

    setIsAuthenticated(true);
    setUser(userData);
    setToken(token);
    
    localStorage.setItem('lead_app_token', token);
    localStorage.setItem('lead_app_user', JSON.stringify(userData));
  }, []);

  const logout = useCallback(() => {
    setIsAuthenticated(false);
    setUser(null);
    setToken(null);
    
    localStorage.removeItem('lead_app_token');
    localStorage.removeItem('lead_app_user');
    localStorage.removeItem('myLeadsFilters'); // Clear persistent search state
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, token, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
